export class PointSchema {
    id = 'pt';
    type = 'circle';
    source = {
        type: 'geojson',
        data: {
            type: 'Feature',
            properties: {
                type: ''
            },
            geometry: {
                type: 'Point',
                coordinates: []
            },
        }
    };
    layout = {};
    paint = {
        'circle-radius': 12,
        'circle-color': '#000000',
        'circle-stroke-width': 2,
        'circle-stroke-color': '#FFFFFF',
    };
}

export class TextPointSchema {
    id = 'pt';
    type = 'symbol';
    source = {
        type: 'geojson',
        data: {
            type: 'Feature',
            properties: {
                color: '#ffffff',
                type: ''
            },
            geometry: {
                type: 'Point',
                coordinates: []
            }
        }
    };
    layout = {
        'text-field': '',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
        'text-ignore-placement': true,
        'text-allow-overlap': true,
    };
    paint = {
        'text-color': ['get', 'color']
    };
}

export class PointBorderSchema {
    id = 'pt';
    type = 'circle';
    source = {
        type: 'geojson',
        data: {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: []
            }
        }
    };
    layout = {};
    paint = {
        'circle-radius': 14,
        'circle-color': '#FFF',
    };
}

export class SymbolSchema {
    id = 'pt';
    type = 'symbol';
    source = {
        type: 'geojson',
        data: {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: []
            }
        }
    };
    properties = {};
    layout = {
        'icon-image': 'current-loc',
        'icon-size': 0.6,
        'icon-anchor': 'center',
    };
}

export class LineSchema {
    id = 'route';
    type = 'line';
    source = {
        type: 'geojson',
        data: {
            type: 'Feature',
            properties: {
                type: ''
            },
            geometry: {
                type: 'LineString',
                coordinates: []
            }
        }
    };
    layout = {
        'line-join': 'round',
        'line-cap': 'round'
    };
    paint = {
        'line-color': 'rgba(0,0,0,1)',
        'line-width': 5
    };
}
